import { render } from "./application-record.vue?vue&type=template&id=0283ad06"
import script from "./application-record.vue?vue&type=script&lang=js"
export * from "./application-record.vue?vue&type=script&lang=js"

import "./application-record.vue?vue&type=style&index=0&id=0283ad06&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__